/* Component Dependencies */
var $ = require('jquery');
var eventPlanningFormTemplate = require('templates/eventPlanningForm.hbs');
var eventPlanningGroupBookingsFormTemplate = require('templates/eventPlanningForm-groupBookings.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');
var DateHandler = require('libs/date-handler');
var Constants = require('libs/constants');
var ResponsiveUtils = require('utils/responsiveUtils');


PubSub.register(AriesComponent.extend({
    type: 'eventPlanningForm',
    template: {
        'eventPlanningForm': eventPlanningFormTemplate,
        'eventPlanningForm-groupBookings': eventPlanningGroupBookingsFormTemplate
    },
    events: {
        'click .error-cross': 'clearErrorField',
        'focus .selectric-input': 'closeDatePicker'
    },
    bindEvents: function($) {
        var _self = this;
        _self.regEx = /^[0-9]*[1-9][0-9]*$/;
        _self.parentSelector = $('[data-component-id="' + _self.componentId + '"]');
        _self.initResponsiveUtils();
        if (_self.parentSelector.find('.m-search-tabs').length) {
            _self.initDateHandler();
            _self.handleSearchFormResize();

            $(window).on('resize', function() {
                _self.handleSearchFormResize.call(_self);
                _self.changeSelectricArrowStyle();
            });

            _self.bindToSelectricInit($);
            _self.$el.find('.l-pos-relative > .l-close-icon').on('click', _self.clearError);
            _self.$el.find('#viewBtn').on('click', _self.handleFormValidation.bind(_self));
        }
    },
    handleFormValidation: function(event) {
        var _self = this,
            validationResult = true,
            $messageBox = _self.$el.find('.m-message-box'),
            size, numberOfRooms, $size, $numberOfRooms;

        $messageBox.addClass('l-display-none');
        $messageBox.find('span.message-items').addClass('l-display-none');

        _self.$el.find('.is-error').removeClass('is-error');
        validationResult = _self.validateRoomAndSize() ? _self.validateDates() : false;

        if (validationResult) {
            $numberOfRooms = _self.$el.find('#numberOfRooms');
            numberOfRooms = $numberOfRooms.val().trim();
            $size = _self.$el.find('#size');
            size = $size.val().trim();
            if(numberOfRooms === '0'){
                $numberOfRooms.val('');
            }else if(numberOfRooms !== ''){
                _self.$el.find('#roomsOnlySelected').val('on');
            }
            if(size === '0'){
                $size.val('');
            }else if(size !== ''){
                _self.$el.find('#roomsAndEventSelected').val('on');
            }
            _self.$el.find('#GroupSalesFindAndReserveSearchActionForm').submit();
        } else {
            $messageBox.removeClass('l-display-none');
            event.preventDefault();
        }
    },
    clearErrorField: function _clearErrorField(event){
      var inputElement = $(event.target).parent().find('input');
      inputElement.val('');
      inputElement.focus();
      $(event.target).removeClass('error-cross');
    },

    closeDatePicker: function _closeDatePicker(event){
      var datepickerContainer = this.$el.find('.js-datepick-container');
      if(datepickerContainer.length && datepickerContainer.hasClass('is-active'))
      { 
        this.$el.find('.js-datepick-container').trigger('click');                
      }                  
    },

    validateDates: function() {
        var _self = this,
            currentDate = new Date(),
            fromDate = '',
            $numOfRooms = _self.$el.find('#numberOfRooms'),
            toDate = '',
            $messageBox = _self.$el.find('.m-message-box'),
            numOfRooms = _self.$el.find('#numberOfRooms').val().trim(),
            $size = _self.$el.find('#size'),
            size,
            validationResult = true;
        if (_self.eventPlanningForm) {
            fromDate = _self.dateHandler.from.date;
            toDate = _self.dateHandler.to.date;
        } else {
            fromDate = _self.$el.find('input[name="fromDate"]').val(),
                toDate = _self.$el.find('input[name="toDate"]').val();
        }
        if ($size.length >= 1) {
            size = $size.val().trim();
        }
        currentDate.setHours(0, 0, 0);
        fromDate = (fromDate !== '') ? new Date(fromDate) : null;
        toDate = (toDate !== '') ? new Date(toDate) : null;
        if (fromDate) {
            if (fromDate <= currentDate) {
                if (numOfRooms === '' && size === '') {
                    _self.addErrorVisuals($numOfRooms);
                    _self.addErrorVisuals($size);
                } else {
                    validationResult = _self.validateRooms(numOfRooms, size, $messageBox, $size, $numOfRooms, validationResult);
                }
                _self.showErrorMessage($messageBox, 'need.space.today.text');
                _self.addErrorVisuals(_self.$el.find('.js-datepick-container .m-dropdown-trigger'));
                validationResult = false;
            } else if (toDate && fromDate.toString() === toDate.toString()) {
                numOfRooms = _self.validatePositiveNumeric(numOfRooms);
                if ($size.length >= 1) {
                    size = $size.val().trim();
                    size = _self.validatePositiveNumeric(size);
                } else {
                    size = false;
                }
                if (!size || numOfRooms) {
                    _self.showErrorMessage($messageBox, 'samedate.error.text');
                    _self.addErrorVisuals(_self.$el.find('.js-datepick-container .m-dropdown-trigger'));
                    validationResult = false;
                }
            }
        } else {
            _self.showErrorMessage($messageBox, 'blankdate.error.text');
            _self.addErrorVisuals(_self.$el.find('.js-datepick-container .m-dropdown-trigger'));
            validationResult = false;
        }
        return validationResult;
    },
    validateRoomAndSize: function() {
        var _self = this,
            $numOfRooms = _self.$el.find('#numberOfRooms'),
            currentDate = new Date(),
            fromDate = _self.$el.find('#hotelFromDate').val(),
            numOfRooms = $numOfRooms.val().trim(),
            $size = _self.$el.find('#size'),
            size,
            $messageBox = _self.$el.find('.m-message-box'),
            validationResult = true;
        if ($size.length >= 1) {
            size = $size.val().trim();
        }

        currentDate.setHours(0, 0, 0);
        fromDate = (fromDate !== '') ? new Date(fromDate) : null;

        if (!fromDate) {
            _self.showErrorMessage($messageBox, 'blankdate.error.text');
            _self.addErrorVisuals(_self.$el.find('.js-datepick-container .m-dropdown-trigger'));
            validationResult = false;
        } else if (fromDate > currentDate) {
            if (numOfRooms === '' && size === '') {
                _self.showErrorMessage($messageBox, 'guest.meeting.required.text');
                _self.addErrorVisuals($numOfRooms);
                _self.addErrorVisuals($size);
                return false;
            }
            validationResult = _self.validateRooms(numOfRooms, size, $messageBox, $size, $numOfRooms, validationResult);
        }
        return validationResult;
    },
    showError: function _showError($messageBox,message,element){
      var _self = this;
      _self.showErrorMessage($messageBox, message);
      _self.addErrorVisuals(element);
      element.parent().append('<span></span>');
      element.parent().find('span').addClass('error-cross');
    },
    validateRooms: function _validateRooms(numOfRooms, size, $messageBox, $size, $numOfRooms, validationResult) {
        var _self = this;

        if (_self.validatePositiveNumeric(numOfRooms)) {
            numOfRooms = parseInt(numOfRooms);
            if (numOfRooms >= 1 && numOfRooms <= 3) {
                _self.showError($messageBox,'res.1To3.required.text',$numOfRooms);
                validationResult = false;
            } else if (numOfRooms >= 4 && numOfRooms <= 9) {
                _self.showError($messageBox,'res.4To9.required.text',$numOfRooms);
                validationResult = false;
            } else if (size !== undefined && !_self.validatePositiveNumeric(size)) {
                if (size !== '' && size !== '0') {
                    _self.showError($messageBox,'event.space.value.text',$size);
                    validationResult = false;
                }
            }
        } else if (size === undefined) {
            _self.showErrorMessage($messageBox, 'guest.room.value.text');
            _self.addErrorVisuals($numOfRooms);
            validationResult = false;
        } else {
            if (!_self.validatePositiveNumeric(size)||!_self.validatePositiveNumeric(numOfRooms)) {
                if (numOfRooms !== '' && !_self.validatePositiveNumeric(numOfRooms) && (size === '0' || size === '')) {
                    _self.showError($messageBox,'guest.room.value.text',$numOfRooms);
                    validationResult = false;
                }
                if (size !== '' && !_self.validatePositiveNumeric(size)) {
                    _self.showError($messageBox,'event.space.value.text',$size);
                    validationResult = false;
                }
            } else if (numOfRooms !== '' && numOfRooms !== '0') {
                _self.showErrorMessage($messageBox, 'guest.room.value.text');
                _self.addErrorVisuals($numOfRooms);
                validationResult = false;
            }
        }
        return validationResult;
    },

    validatePositiveNumeric: function(num) {

        return this.regEx.test(num);
    },
    showErrorMessage: function($messageBox, errorKey) {
        $messageBox.find('span[data-error-key="' + errorKey + '"]').removeClass('l-display-none');
    },
    addErrorVisuals: function($element) {
        $element.addClass('is-error');
    },
    bindToSelectricInit: function($) {
        var _self = this;
        var $selectFields = _self.parentSelector.find('.mi-select');
        var count = 0;

        $selectFields.each(function() {
            $(this).on('selectric-init', function() {
                count++;
                if (count === $selectFields.length) {
                    _self.changeSelectricArrowStyle();
                    _self.retainInputFieldValues();
                    _self.parentSelector.find('input[data-type="text"], .js-toggle-picker .m-dropdown-trigger, select').one('click change', _self.preserveInputFieldValues.bind(_self));
                }
            });
        });
    },
    formattedDate: function(date){
        date = new Date(date);
        var submitDate = String(date.getDate()),
        submitMonth = String(date.getMonth() + 1),
        submitYear = String(date.getFullYear());
        if (submitMonth.length < 2) submitMonth = '0' + submitMonth;
        if (submitDate.length < 2) submitDate = '0' + submitDate;
        return submitMonth+"/"+submitDate+"/"+submitYear;
    },
    retainInputFieldValues: function() {
        var _self = this,
            setValue = {
              "hotelFromDate": "js-submit-from",
              "hotelToDate": "js-submit-to"
            };
        _self.eventPlanningForm = JSON.parse(sessionStorage.getItem('eventPlanningForm'));
        if (_self.eventPlanningForm) {
            _self.dateHandler.from.date = new Date(_self.eventPlanningForm['hotelFromDate']);
            _self.dateHandler.pickaDatePlugin.setDateOnFormatChange(_self.dateHandler, 'from');
            _self.dateHandler.to.date = new Date(_self.eventPlanningForm['hotelToDate']);
            _self.dateHandler.pickaDatePlugin.setDateOnFormatChange(_self.dateHandler, 'to');
            for (var key in _self.eventPlanningForm) {
                if(setValue[key]){
                  _self.$el.find('.'+ setValue[key]).val(_self.formattedDate(_self.eventPlanningForm[key]));
                }
                if (key.indexOf('-') === -1) {
                    _self.$el.find('#' + key).val(_self.eventPlanningForm[key]);
                } else {
                    (function(localKey) {
                        setTimeout(function() {
                            _self.parentSelector.find('.' + localKey + ' .mi-select').val(_self.eventPlanningForm[localKey]).selectric('refresh');
                        });
                    })(key);
                }
            }
        }
    },
    preserveInputFieldValues: function() {
        var _self = this;
        var eventPlanningForm = {};
        setInterval(function() {
            _self.$el.find('input[data-type=text], select').each(function() {
                var $this = $(this);
                if ($this.is('input')) {
                    eventPlanningForm[$this.attr('id')] = $this.val();
                } else {
                    eventPlanningForm[$this.attr('id')] = $this.find('option:selected').val();
                    eventPlanningForm['selectric-' + $this.attr('class').split('mi-select ')[1]] = $this.find('option:selected').val();
                }
            });
            sessionStorage.setItem('eventPlanningForm', JSON.stringify(eventPlanningForm));
        }, 1000);
    },
    clearError: function(event) {
        var inputElement = $(event.target).parent().find('input');
        inputElement.removeClass('is-error');
        inputElement.val('');
        inputElement.focus();
        $(event.target).removeClass('l-close-icon icon m-dropdown-trigger dropdown-is-active');
    },
    changeSelectricArrowStyle: function() {
        var _self = this;
        var datePickerContainer = _self.$el.find('.js-datepick-container');
        var datePickerTextbox = _self.$el.find('.js-toggle-picker');

        if (datePickerContainer.data('error-exists')) {
            datePickerContainer.find('.m-dropdown-trigger').addClass('is-error');
        }
        datePickerTextbox.css('border-radius', '0.25rem');

        _self.$el.find('.selectric b').each(function() {
            $(this).addClass('button m-dropdown-trigger');
        });
    },
    handleSearchFormResize: function() {
        var $body = $('body');
        if (this.responsiveUtils.isMobile() || this.responsiveUtils.isTablet()) {
            $body.addClass('is-form-takeover');
        } else {
            $body.removeClass('is-form-takeover');
        }
        this.dateHandler.pickaDatePlugin.handleFormat();
    },
    initResponsiveUtils: function() {
        this.responsiveUtils = ResponsiveUtils.create({
            isTakeOverRequired: false
        });
        this.responsiveUtils.init();
    },
    getTakeOverVariation: function() {
        return Constants.SEARCH_FORM.VARIATIONS.EDIT_SEARCH;
    },
    isAndroidDevice: function() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('android') > -1; //&& ua.indexOf('mobile');
    },
    initDateHandler: function() {
        var _self = this;
        _self.dateHandler = new DateHandler({
            $el: this.$el.find('.js-datepick-container'),
            $parent: _self,
            addCustomHeaderStyle: true
        });
        _self.dateHandler.init();
    }
}));
